<template>
  <div class="battery-store__wrapper">
    <div v-if="isLoading" class="loading-indicator"><MoonLoader size="75px" color="#ffffff"></MoonLoader></div>
    <div class="css-grid battery-store__header">
      <div class="battery-store__header-name">Battery Order</div>
    </div>
    <ProductView v-if="showProductView"></ProductView>
    <ShippingView v-if="showShippingView"></ShippingView>
    <PaymentView v-if="showPaymentView"></PaymentView>
    <ErrorMessageView v-if="showErrorView"></ErrorMessageView>
    <SuccessMessageView v-if="showSuccessView"></SuccessMessageView>
    <BatteryOrderHistoryView v-if="showOrderHistory"></BatteryOrderHistoryView>

    <div class="battery-store__footer"></div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min.js';
  import ProductView from '../battery-store/ProductView.vue';
  import ShippingView from '../battery-store/ShippingView.vue';
  import PaymentView from '../battery-store/PaymentView.vue';
  import ErrorMessageView from '../battery-store/ErrorMessageView.vue';
  import SuccessMessageView from '../battery-store/SuccessMessageView.vue';
  import BatteryOrderHistoryView from '../battery-store/BatteryOrderHistoryView.vue';

  export default {
    name: 'BatteryStoreLayout',
    components: {
      MoonLoader,
      ProductView,
      ShippingView,
      PaymentView,
      ErrorMessageView,
      SuccessMessageView,
      BatteryOrderHistoryView,
    },
    computed: {
      ...mapGetters('batteryStore', ['currentSection', 'shippingInfoValid', 'orders', 'loaders']),
      showProductView() {
        return this.currentSection === 'addItems';
      },
      showShippingView() {
        return this.currentSection === 'shippingInfo';
      },
      showPaymentView() {
        return this.shippingInfoValid && this.currentSection === 'shippingInfo';
      },
      showErrorView() {
        return this.currentSection === 'errorMessage';
      },
      showSuccessView() {
        return this.currentSection === 'successMessage';
      },
      showOrderHistory() {
        return this.orders.length > 0;
      },
      isLoading() {
        return this.loaders.submitting;
      }
    },
    mounted() {
      this.$store.dispatch('batteryStore/getProducts');
      this.$store.dispatch('batteryStore/getLocations');
      this.$store.dispatch('batteryStore/getOrders');
      this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: false });
    },
    beforeRouteLeave(to, from, next) {
      this.$store.dispatch('batteryStore/resetForm');
      next();
    },
  };
</script>
